export default "__VITE_ASSET__BsdaUkbI__"